export const containerStyles = {
  display: "grid",
  gridTemplateColumns: ["1fr", "1fr 1fr"],
  gap: "16px",
  width: "100%",
  mb: 3
};

export const cardStyles = (selected) => ({
  cursor: "pointer",
  borderRadius: "20px",
  padding: "18px 20px",
  border: selected ? "2.5px solid #0f172a" : "1px solid #e2e8f0",
  backgroundColor: "#ffffff",
  transition: "all 0.2s ease-in-out",
  boxSizing: "border-box",
  width: "100%",
  "&:hover": {
    borderColor: selected ? "#0f172a" : "#94a3b8"
  },
});